import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/core/api/client';

/**
 * Hook for creating an intake-form engagement.
 * Feature 103 (The Key pilot) — wayfinder ticket 18: records the billable
 * engagement on button click, mirroring useCreateCalendlyEngagement.
 */

type CreateIntakeFormEngagementRequest = {
  providerId: string;
  profileViewEngagementId?: string;
};

type CreateIntakeFormEngagementResponse = {
  id: string;
  providerId: string;
  careSeekerId: string;
  status: string;
  createdAt: string;
};

async function createIntakeFormEngagement(
  data: CreateIntakeFormEngagementRequest,
): Promise<CreateIntakeFormEngagementResponse> {
  const response = await apiClient.post<CreateIntakeFormEngagementResponse>(
    '/consultations/intake-form',
    data,
  );

  return response.data;
}

export function useCreateIntakeFormEngagement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createIntakeFormEngagement,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consultations'] });
      queryClient.invalidateQueries({ queryKey: ['engagements'] });
    },
  });
}
